<div class="items-wrapper">
  <mat-form-field (click)="$event.stopPropagation()">
    <mat-label>{{ 'COMMON.search_by_name' | translate }}</mat-label>
    <input [(ngModel)]="name" (ngModelChange)="filterChange($event)" matInput autocomplete="off">
  </mat-form-field>

  <ng-content></ng-content>
</div>
